// The sign-in page: chrome around <AuthForm />.
//
// The form itself lives in components/AuthForm because the wizard also needs to
// create accounts, at its last step, for a visitor who built an agent before
// signing up. Everything about how authentication behaves is in there; what is
// left here is the things that are true of this being a *page* -- the logo, the
// way back to the marketing site, and the footer.
//
// The landing page's buttons point at /signin?mode=signup, so somebody who
// clicked "Create an account" arrives on the create-account form rather than on
// a sign-in form they have to notice and switch away from. Only that one value
// is honored -- an unrecognized ?mode falls back to signing in.

import { Link, useSearchParams } from "react-router-dom";
import AuthForm from "../components/AuthForm";
import Footer from "../components/Footer";
import { Logo } from "../components/Logo";
import { PRODUCT_NAME, PRODUCT_TAGLINE } from "../lib/brand";
import { Card } from "../components/ui";

export default function SignIn() {
  const [params] = useSearchParams();

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <main className="flex flex-1 items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <div className="mb-8 flex flex-col items-center text-center">
            {/* Clickable, because this is the only way back to the marketing
                page for someone who landed here from a bookmark and wants to
                know what they are signing up for. */}
            <Link to="/" aria-label={PRODUCT_NAME} className="flex">
              <Logo />
            </Link>
            <p className="mt-3 text-sm text-slate-500">{PRODUCT_TAGLINE}</p>
          </div>

          <Card>
            <AuthForm initialMode={params.get("mode") === "signup" ? "signup" : "signin"} />
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
}
